var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRatingStarOffOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#919191",
  strokeWidth: 0.9,
  d: "M17.707.57c.402-.12.498-.076.586 0 .137.121.252.307.358.547l4.972 10.543 11.09 1.69c.303.052.538.13.69.261.101.087.147.201.147.34 0 .244-.17.497-.434.774l-8.013 8.193 1.893 11.537c.015.571-.01.791-.127.96-.066.097-.166.135-.29.135-.203 0-.415-.077-.64-.212l-9.94-5.478-9.937 5.478c-.235.134-.447.212-.641.212-.133 0-.242-.034-.311-.134a.93.93 0 0 1-.147-.517l1.933-11.982-8.025-8.184c-.258-.293-.421-.548-.421-.782 0-.139.046-.253.147-.34.152-.131.387-.21.682-.259l11.098-1.692L17.35 1.117c.105-.24.22-.426.357-.546z"
})));
export default SvgRatingStarOffOutline;